import { useState } from 'react';
import {
  TextField,
  Button,
  Alert,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/store/authStore';

/**
 * 登录表单组件的属性
 */
export interface LoginFormProps {
  /** 登录成功后的回调函数 */
  onSuccess: () => void;
}

/**
 * 登录表单组件
 *
 * 包含用户名、密码输入框和提交按钮，处理表单验证和登录逻辑。
 *
 * @example
 * <LoginForm onSuccess={() => navigate('/')} />
 */
export function LoginForm({ onSuccess }: LoginFormProps) {
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const success = await login(username, password);

    if (success) {
      onSuccess();
    } else {
      setError(t('login.invalidCredentials'));
    }

    setLoading(false);
  };

  return (
    <>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label={t('login.username')}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          margin="normal"
          required
          autoFocus
        />
        <TextField
          fullWidth
          label={t('login.password')}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
          required
        />
        <Button
          fullWidth
          type="submit"
          variant="contained"
          size="large"
          sx={{ mt: 3 }}
          disabled={loading}
        >
          {loading ? t('login.signIning') : t('login.signIn')}
        </Button>
      </form>
    </>
  );
}
